import { Button, ButtonTheme } from '@apply/components';

export const DisabledRequestDrawButton = () => (
    <Button
        id='secondaryButton'
        theme={ButtonTheme.Secondary}
        width='160px'
        disabled={true}
    >
        Draw Pending
    </Button>
);
